<div *ngIf="popupName == 'addPopup'">
  <div class="cardLayout">
    <ion-row>
      <ion-col size="12">
        <div class="popup-heading">
          <div>
            <p class="fs-16 fs_14ForMobile font_bold cl-black">360 Review</p>
          </div>
          <div class="popup-close">
            <span [mat-dialog-close] class="ml-35 mr-5 fs-20 material-icons popup-close-icon cp">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>
  </div>
  <div class="cardBox">
    <table class="table-container">
      <thead>
        <tr>
          <th>Name</th>
          <th>Company Name</th>
          <th>Email ID</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of externalUser; let i = index">
          <td>
            <mat-form-field class="custom-input w-100 mat-height40 mat-input-style">
              <input type="text" matInput placeholder="Type here" class="font_regular" [(ngModel)]="item.name">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field class="custom-input w-100 mat-height40 mat-input-style">
              <input type="text" matInput placeholder="Type here" class="font_regular" [(ngModel)]="item.companyName">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field class="custom-input w-100 mat-height40 mat-input-style">
              <input type="text" matInput placeholder="Type here" class="font_regular" [(ngModel)]="item.email">
            </mat-form-field>
          </td>
          <td>
            <div class="tableAddRemoveIcon">
              <img *ngIf="i === externalUser.length - 1" class="cp" title="Add" src="././assets/icon/Plus_icon.svg"
                (click)="createExtUserAddTableRow()">
              <img *ngIf="externalUser.length > 1" class="cp ml-5" title="Remove" src="././assets/icon/Minus_icon.svg"
                (click)="createExtUserRemoveTableRow(i)">
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <button type="button" class="add_btn fs-14 fs_12ForMobile mr-5 mt-10 text-center"
      [style.background-color]="buttonColorName" (click)="onClickSave()">Save</button>
  </div>
</div>

<div *ngIf="popupName == 'edit'">
  <div class="cardLayout">
    <ion-row>
      <ion-col size="12">
        <div class="popup-heading">
          <div>
            <p class="fs-16 fs_14ForMobile font_bold cl-black">External</p>
          </div>
          <div class="verticle-center">
            <div>
              <button type="button" class="add_btn fs-14 fs_12ForMobile" (click)="isEdit()"
                [style.background-color]="buttonColorName">Edit</button>
            </div>
            <div class="popup-close">
              <span [mat-dialog-close] class="ml-35 mr-5 fs-20 material-icons popup-close-icon cp">close</span>
            </div>
          </div>

        </div>
      </ion-col>
    </ion-row>
  </div>
  <div class="cardBox">
    <div *ngFor="let data of externalUser">
      <div class="contentBox">
        <div class="font_regular fs-14 fs_12ForMobile">Name : <span class="font_bold">{{data.name}}</span></div>
        <div class="font_regular fs-14 fs_12ForMobile mt-5">Company Name : <span class="font_bold">{{data.companyName}}</span></div>
        <div class="font_regular fs-14 fs_12ForMobile mt-5">Email Id : <span class="font_bold">{{data.email}}</span></div>
      </div>
    </div>
  </div>
</div>